class FAQ {
	constructor() {
		this.toggle = $('[data-question]')

		this.events()
	}

	events() {
		this.toggle.click(e => {
			e.preventDefault()
			let toggle = $(e.currentTarget)

			if (toggle.parent().hasClass('active')) {
				this.close(toggle)
			} else {
				this.open(toggle)
			}
		})
	}

	close(toggle) {
		toggle.parent().removeClass('active')
	}

	open(toggle) {
		toggle.parent().addClass('active')
	}
}

new FAQ()
